// sessionStorage throws rather than no-ops when it is disabled or full, so every access goes
// through here and degrades to the fallback instead of taking the caller down with it.
const safely = (fn, fallback = null) => {
  try {
    return fn();
  } catch {
    return fallback;
  }
};

export const setSessionStorageItem = (key, value) =>
  safely(() =>
    sessionStorage.setItem(
      key,
      typeof value === 'string' ? value : JSON.stringify(value)
    )
  );

export const getSessionStorageItem = key =>
  safely(() => {
    const item = sessionStorage.getItem(key);
    if (item === null) return null;
    return safely(() => JSON.parse(item), item);
  });

export const removeSessionStorageItem = key =>
  safely(() => sessionStorage.removeItem(key));

export const clearSessionStorage = () => safely(() => sessionStorage.clear());
